import React from "react";
import PropTypes from "prop-types";
import { Pagination as AntPagination } from "antd";
import { UiPagination } from "./Pagination.style";
/**
 * 分頁
 */

export const Pagination = ({
  variant = "default",
  textcolor = "#fff",
  current = 1,
  defaultCurrent = 1,
  pageSizeOptions = [25, 20, 15, 10],
  total,
  onChange,
  defaultPageSize = 10
}) => {
  return /*#__PURE__*/React.createElement(UiPagination, {
    variant: variant,
    textcolor: textcolor
  }, total > 0 && total > defaultPageSize && /*#__PURE__*/React.createElement(AntPagination, {
    current: current,
    defaultCurrent: defaultCurrent,
    pageSizeOptions: pageSizeOptions,
    total: total,
    onChange: onChange,
    defaultPageSize: defaultPageSize
  }));
};
export default Pagination;
Pagination.propTypes = {
  variant: PropTypes.string,
  textcolor: PropTypes.string,
  current: PropTypes.number,
  defaultCurrent: PropTypes.number,
  pageSizeOptions: PropTypes.array,
  total: PropTypes.number,
  onChange: PropTypes.func,
  defaultPageSize: PropTypes.number
};